export type ErrorsTranslation = {
  permissionError: {
    button: string;
    message: string;
    title: string;
  };
};

export const errorsTranslation: ErrorsTranslation = {
  permissionError: {
    button: 'OK',
    message: 'Nie masz wystarczających uprawnień do wykonania tej akcji.',
    title: 'Brak uprawnień',
  },
};
